import { Checkbox } from 'antd';
import React from 'react';
import { BaseFormItem } from './BaseFormItem';
import { IBaseFormItemProps } from './form.type';

interface IProps extends React.ComponentProps<typeof Checkbox.Group>, IBaseFormItemProps {}

export function BaseCheckbox(props: IProps) {
  return (
    <BaseFormItem {...props}>
      <Checkbox.Group {...props} style={{ maxHeight: 400, overflowY: 'scroll' }} className="checkbox-list" />
    </BaseFormItem>
  );
}
